import { Container } from "@chakra-ui/react";
import React from "react";

export const TheListContainer: React.FC = ({ children }) => (
  <Container maxW="container.lg" layerStyle="the-list-bg" mt={5} p={2}>
    { children }
  </Container>
);
